/**
 * Returns all correlations of a certain atom type.
 *
 * @param {Values} correlations
 * @param {string} mf
 */
export function getCorrelationsByAtomType(correlations, atomType) {
    return correlations
        ? correlations.filter((correlation) => correlation.atomType === atomType)
        : [];
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0Q29ycmVsYXRpb25zQnlBdG9tVHlwZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy91dGlsaXRpZXMvZ2VuZXJhbC9nZXRDb3JyZWxhdGlvbnNCeUF0b21UeXBlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBOzs7OztHQUtHO0FBQ0gsTUFBTSxVQUFVLHlCQUF5QixDQUN2QyxZQUFvQixFQUNwQixRQUFnQjtJQUVoQixPQUFPLFlBQVk7UUFDakIsQ0FBQyxDQUFDLFlBQVksQ0FBQyxNQUFNLENBQUMsQ0FBQyxXQUFXLEVBQUUsRUFBRSxDQUFDLFdBQVcsQ0FBQyxRQUFRLEtBQUssUUFBUSxDQUFDO1FBQ3pFLENBQUMsQ0FBQyxFQUFFLENBQUM7QUFDVCxDQUFDIn0=